import { Injectable } from '@angular/core';

import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { NEVER, Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { GlobalSettingsService } from '../services/ui/global-settings.service';
import { UserService } from '../services/sections/shared/user.service';

@Injectable({
	providedIn: 'root'
})
export class ConfigureRoundsUserRightResolver implements Resolve<Observable<boolean>> {

	constructor(
		private router: Router,
		private userService: UserService
	) { }

	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot) {

		GlobalSettingsService.isSecondaryLoaderLoading = true;

		return this.userService
			.canConfigureRounds(activatedRouteSnapshot.paramMap.get('token'))
			.pipe(
				catchError(() => {
					this.router.navigate(['/404']);
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					return NEVER;
				})
			);
	}
}
